document.addEventListener('DOMContentLoaded', () => {
  const toggleButton = document.querySelector('.menu-single-row__mobile-toggle');
  const closeButton = document.querySelector('.menu-single-row__mobile-close');
  const overlay = document.querySelector('.menu-single-row__mobile-overlay');
  const menu = document.querySelector('.menu-single-row__mobile-nav');

  /* Move mobile nav & overlay to <body> so they escape the header's
     backdrop-filter containing block (which breaks position:fixed). */
  if (menu) document.body.appendChild(menu);
  if (overlay) document.body.appendChild(overlay);

  const openMobileMenu = () => {
    if (!menu || !overlay) return;
    menu.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeMobileMenu = () => {
    if (!menu || !overlay) return;
    menu.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  const toggleSubmenu = (button) => {
    const submenuId = button.getAttribute('data-submenu-id');
    const submenu = document.getElementById(submenuId);
    if (!submenu) return;

    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', !isExpanded);
    submenu.classList.toggle('is-open');
  };

  if (toggleButton) {
    toggleButton.addEventListener('click', openMobileMenu);
  }
  
  if (closeButton) {
    closeButton.addEventListener('click', closeMobileMenu);
  }

  if (overlay) {
    overlay.addEventListener('click', closeMobileMenu);
  }

  document.querySelectorAll('.menu-single-row__mobile-submenu-toggle').forEach(button => {
    button.addEventListener('click', () => toggleSubmenu(button));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu && menu.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });
});
